// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3zqjr","requiredAsterisk":"Info_requiredAsterisk__3fmnG"};